/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { dataTablesRequest } from '../models/dataTablesRequest';
import type { team } from '../models/team';
import type { team_member } from '../models/team_member';
import type { vw_team } from '../models/vw_team';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TeamService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get Team datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postTeamDataTables({
        requestBody,
        storeId,
    }: {
        requestBody: dataTablesRequest,
        /**
         * The unique identifier of the store
         */
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/team/dataTables',
            query: {
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Team Member datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postTeamMemberDataTables({
        teamId,
        requestBody,
    }: {
        /**
         * The unique identifier of the team
         */
        teamId: string,
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/team/member/dataTables',
            query: {
                'teamId': teamId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve a list of Teams
     * @returns vw_team A list of teams
     * @throws ApiError
     */
    public getTeams(): CancelablePromise<Array<vw_team>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/teams',
        });
    }

    /**
     * Get team by id
     * @returns vw_team The team data
     * @throws ApiError
     */
    public getTeam({
        id,
    }: {
        id: string,
    }): CancelablePromise<vw_team> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/team/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Team not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a team by id
     * @returns any Team deleted successfully
     * @throws ApiError
     */
    public deleteTeam({
        id,
    }: {
        /**
         * The team id
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/team/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Team not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get team by storeId
     * @returns vw_team The team data
     * @throws ApiError
     */
    public getTeamByStoreId({
        storeId,
    }: {
        storeId: string,
    }): CancelablePromise<vw_team> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/team/byStoreId/{storeId}',
            path: {
                'storeId': storeId,
            },
            errors: {
                404: `Team not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new Team
     * @returns any Team created successfully
     * @throws ApiError
     */
    public postTeam({
        requestBody,
    }: {
        requestBody: team,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/team',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update an existing Team
     * @returns any Team updated successfully
     * @throws ApiError
     */
    public putTeam({
        requestBody,
    }: {
        requestBody: team,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/team',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Team not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Add member to team
     * @returns any Team created successfully
     * @throws ApiError
     */
    public postTeamAddMember({
        requestBody,
    }: {
        requestBody: team_member,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/team/addMember',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Remove an user from team member
     * @returns any User removeed successfully
     * @throws ApiError
     */
    public deleteTeamRemoveFromMember({
        teamMemberId,
    }: {
        /**
         * a field of team member id
         */
        teamMemberId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/team/removeFromMember/{teamMemberId}',
            path: {
                'teamMemberId': teamMemberId,
            },
            errors: {
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }

}
